import { Card, Typography } from '../../components/primitives';
import { VolumeDiscountTableFooter } from '../../components/text/VolumeDiscountTableFooter';
import { useCartHook } from '../../hooks/cartHook';
import { testId } from '../../utils';
import { VolumeDiscountCell } from './VolumeDiscountCell';
import { useTranslation } from '@rpi/i18n';
import React from 'react';

export const VolumeDiscountTable: React.FC<{ 'data-testid': string }> = ({
  'data-testid': dataTestId,
}) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'route.cart' });
  const { volumeDiscountsByUnit } = useCartHook();

  return (
    <div>
      {volumeDiscountsByUnit && (
        <Card {...testId(dataTestId, 'volume-discount-table')}>
          <div className="text-center p-8">
            <Typography variant="sub-title" className="text-black-dark">
              {t('volume_pricing')}
            </Typography>
            <div className="p-4 mb-2 flex flex-col gap-4">
              {volumeDiscountsByUnit.map(
                (
                  discount: {
                    minUnits: number | undefined;
                    maxUnits: number | undefined;
                    discountPercentage: number | undefined;
                  },
                  index: React.Key | null | undefined,
                ) => (
                  <VolumeDiscountCell
                    key={index}
                    {...testId(dataTestId, `${index}`)}
                    {...discount}
                  />
                ),
              )}
            </div>
            <VolumeDiscountTableFooter />
          </div>
        </Card>
      )}
    </div>
  );
};
